import { createContext } from "react";

const FichasTecnicasDesarrolloContext = createContext();

export default FichasTecnicasDesarrolloContext;
